import EnrollmentsForm from './Form'

export default function EnrollmentsFormIndex() {
  return <EnrollmentsForm />
}
